var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-notify',{attrs:{"type":_vm.type,"color":"#F15945","background":"#FFFFFF"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"huisuiyunfont pop-up-icon"},[_vm._v(_vm._s('\ue615'))]),_c('span',[_vm._v(_vm._s(_vm.message))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }